export type LevelAnswerKind = "know" | "unsure" | "dont";
export interface LevelAnswer { band: number; answer: LevelAnswerKind }
export const TEST_LENGTH = 20;
export const START_BAND = 3;

export function nextBand(band: number, a: LevelAnswerKind): number {
  if (a === "know") return Math.min(5, band + 1);
  if (a === "dont") return Math.max(1, band - 1);
  return band;
}
export function estimateKnown(answers: LevelAnswer[]): number {
  const tail = answers.slice(-10);
  if (tail.length === 0) return 0;
  const avg = tail.reduce((s, x) => s + x.band, 0) / tail.length;
  return Math.round(avg * 600);
}
export function startingBand(known: number): 1 | 2 | 3 | 4 {
  if (known < 1000) return 1;
  if (known < 2000) return 2;
  if (known < 3000) return 3;
  return 4;
}
export function pickTestWords<T extends { band: number }>(pool: T[]): T[] {
  // 每个 band 取均分样本;真正自适应选词在运行时按当前 band 抽未答过的词
  const byBand = new Map<number, T[]>();
  for (const w of pool) {
    byBand.set(w.band, [...(byBand.get(w.band) ?? []), w]);
  }
  const out: T[] = [];
  for (let b = 1; b <= 5; b++) {
    const arr = byBand.get(b) ?? [];
    out.push(...arr.slice(0, 4));
  }
  return out;
}
